var _circle, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _circle2, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHauntedFlashlight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#F1F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4499 30.908L75.1752 16.15C75.1752 16.15 84.9003 25.9771 84.5252 43.1636C84.15 60.35 74 70.5 74 70.5L51.4499 56C51.4499 56 47.6 51.2163 47.6 43.1636C47.6 35.1108 51.4499 30.908 51.4499 30.908Z",
    fill: "#F9E88D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40002 43.4834C3.40002 40.1374 5.78748 37.2679 9.07762 36.6593L14.5006 35.6562V51.2483L9.15414 50.3212C5.82848 49.7445 3.40002 46.8587 3.40002 43.4834Z",
    fill: "#C13925"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5004 35.6562H41.0648V51.2483H14.5004C14.5004 51.2483 11.8696 50.5104 11.8696 43.4523C11.8696 36.3941 14.5004 35.6562 14.5004 35.6562Z",
    fill: "#F75322"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9827 43.4523C61.9827 52.1522 57.8485 59.2048 52.7487 59.2048C52.0868 59.2048 51.4413 59.086 50.8189 58.8603L45.6527 56.3174L38.3126 52.5913C36.8482 51.8479 35.631 50.669 35.2075 49.0822C34.8517 47.7488 34.52 45.8787 34.52 43.5397C34.52 41.1585 34.8637 39.2632 35.2268 37.9255C35.6448 36.3853 36.8166 35.2314 38.2273 34.4851L46.2623 30.2342L50.8189 28.0442C51.4413 27.8185 52.0868 27.6997 52.7487 27.6997C57.8485 27.6997 61.9827 34.7524 61.9827 43.4523Z",
    fill: "#C13925"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.6413,
    cy: 43.2598,
    rx: 6.54485,
    ry: 13.5709,
    fill: "#F5C58A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4601 41.1423C45.4601 34.9504 48.1978 31.1218 48.8609 30.17C45.2676 32.2875 38.6394 35.0787 37.1507 36.362C35.6621 37.6453 35.6749 40.0836 35.5145 41.7839L45.4601 41.1423Z",
    fill: "#9A2615"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1402 36.8658C14.203 36.7161 14.3494 36.6187 14.5117 36.6187H33.9667C34.2401 36.6187 34.4341 36.8851 34.3502 37.1453L33.9684 38.3286C33.9147 38.4951 33.7599 38.6078 33.585 38.6078H14.0155C13.7276 38.6078 13.5326 38.3146 13.6439 38.0492L14.1402 36.8658Z",
    fill: "#C13925"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4297,
    cy: 37.7416,
    r: 1.76454,
    fill: "#22262A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8973 47.9894C47.9229 48.2104 48.1233 48.3706 48.3414 48.3268C49.3868 48.1167 50.3378 47.566 51.0417 46.7551C51.834 45.8424 52.2559 44.6663 52.2245 43.4581C52.1931 42.2499 51.7106 41.0972 50.872 40.2269C50.1269 39.4537 49.1486 38.9531 48.0937 38.7977C47.8736 38.7653 47.6818 38.9356 47.6678 39.1577L47.4337 42.866C47.4036 43.3436 47.416 43.8229 47.4709 44.2982L47.8973 47.9894Z",
    fill: "#F9F2EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHauntedFlashlight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HauntedFlashlight.2a40a5d6c45f3b64e7e3788cf2f78537.svg";